import type {Role} from "../shared/types.ts";

import {getAge} from "./age.ts";

/**
 * Determines if the birthday provided is older than 13 years.
 * The day is irrelevant for this calculation since our business rules
 * dictate that the last of the month is used. (We don't collect day of birth,
 * only month and year)
 *
 * NOTE: This function is for logged-out users. For logged-in users, it's more
 * convenient to use isConsideredOverAgeGate() or isDefinitelyOverAgeGate()
 * instead.
 *
 * @param birthday - a users birthday
 * @returns True if the birthday is over 13 years, false otherwise
 */
export function isDateOverAgeGate(birthday: Date | string): boolean {
    return getAge(birthday) >= 13;
}

/**
 * Determines if the date is over the age gate OR the user does not have the learner role.
 *
 * @param birthday - a user's birthday
 * @param role - the user's role in the system
 * @returns True if the birthday is over 13 years or user is not a learner, false otherwise
 */
export function isDateConsideredOverAgeGate(
    birthday: Date | string,
    role: Role,
): boolean {
    return isDateOverAgeGate(birthday) || role !== "learner";
}
